import SVG from 'assets/img/dash-noData.svg';
import styled from 'styled-components';

export const HypoEmptyState = () => {
  return (
    <StyledHypoEmptyState>
      <div className="image-bg">
        <img src={SVG} />
      </div>
      <p className="text">
        No Hypoglycemia Events Reported <br />
        During This Time Span.
      </p>
    </StyledHypoEmptyState>
  );
};

const StyledHypoEmptyState = styled.div`
  padding: 8px 16px 16px;
  display: grid;
  place-items: center;
  .image-bg {
    position: relative;
    width: 200px;
    height: 200px;
    display: grid;
    place-items: center;
    background: radial-gradient(
      50% 50% at 50% 50%,
      rgba(60, 192, 195, 0.3) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  .text {
    font-family: 'dana-bold';
    font-size: 14px;
    text-align: center;
    color: #753cbe;
    direction: ltr;
    width: 100%;
  }
  @media screen and (min-width: 1024px) {
    padding: 100px 0 200px;
    img {
      width: 205px;
      height: 200px;
    }
    .image-bg {
      width: 550px;
      height: 500px;
    }
    .text {
      font-size: 28px;
      line-height: 56px;
    }
  }
`;
